export default __webpack_public_path__ + "static/media/Graphics_image_2019_09_04T17_14_53_025Z-min.cabb3186.png";